import React from 'react';
import { Outlet } from 'react-router-dom';
import { useWorkspaceContext } from '../providers/WorkspaceProvider';
import LeftSidebar from './LeftSidebar';

export default function Workspace() {
  const { theme, mobileTab } = useWorkspaceContext();

  return (
    <div
      className={`flex flex-1 min-h-0 overflow-hidden ${
        theme === 'dark' ? 'bg-black' : 'bg-white'
      }`}
      style={{ fontFamily: 'Inter, sans-serif' }}
    >
      {/* Col 1: App sidebars */}
      <LeftSidebar />

      {/* Col 2 & Col 3: Nested router outlets */}
      <div className={`${mobileTab === 0 ? 'hidden md:flex md:flex-1' : 'flex flex-1'} min-w-0 h-full`}>
        <Outlet />
      </div>
    </div>
  );
}
